<template lang="pug">
#visualizar-contrato-originacao
    BaseHeader(
        :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.subtituloVisualizar")',
        :voltarPara='true',
        :exibeBotao='false'
    )

    section.visualizar-contrato-originacao__body
        .visualizar-contrato-originacao__card
            h1 {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.subtitulo') }}
            CardEmpresaVisualizarContratoAlvorada(
                v-if='isAlvorada',
                :payload='payload'
            )
            card(v-else)
                .row
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.numeroContrato') }}
                        span.data-value
                            | {{ formatarNumeroContrato(this.payload.dadosContratoOriginacao.numeroContrato) }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.cultura') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.materialNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.safra') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.safraNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.volumeContratado') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.volumeContratado }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.volumeRecebido') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.volumeRecebido }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.dataPagamento') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.dataPagamento }}

                .row
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.estado') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.estadoSigla }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.localidade') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.municipioNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.condicaoFrete') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.condicaoFrete }}
                    .col-2.data-display
                        span.data-title
                            | {{ getTitulo() }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.localCondicaoFrete }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.valorContrato') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.valorContrato }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.dataContrato') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.dataContrato }}
                .row
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.fornecedor') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.fornecedorParceiroNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.cnpjFornecedor') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.subEmpresaCnpj }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.segmento') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.segmentoNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.canal') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.canalNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.gestorTerritorial') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.gestorTerritorialNome }}

                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.gerenteComercial') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.gerenteComercialNome }}

                .row
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.regional') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.regionalNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.gerenteRegional') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.gerenteRegionalNome }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.status') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.status }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.tipoContrato') }}
                        span.data-value
                            | {{ this.payload.dadosContratoOriginacao.tipoContratoOffline }}
                    .col-2.data-display
                        span.data-title
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.eudr') }}
                        span.data-value
                            | {{ eudrFormatado(this.payload.dadosContratoOriginacao.eudr) }}

            .button-edicao-contrato(
                v-if='this.payload.dadosContratoOriginacao.statusEmpresaCodigo === "NAO_VISUALIZADO" || this.payload.dadosContratoOriginacao.statusEmpresaCodigo === "VISUALIZADO"'
            )
                el-button(type='primary', @click='editarContrato()') {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.subtituloEditarContrato') }}

            section.visualizar-contrato-originacao__territorio_resumo(
                v-if='mostrarDadosVolumeTerritorio()'
            )
                h2.mt-4.mb-4 {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumePorTerritorio') }}
                    section.d-flex.mb-4
                        .visualizar-contrato-originacao__card__territorios
                            span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeMaximoPorTerritorio') }}
                            span {{ payload.volumeTerritorios.volumeMaximoTerritorio }} (t)

                        .visualizar-contrato-originacao__card__territorios.mr-4.ml-4
                            span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeMedioPorTerritorio') }}
                            span {{ payload.volumeTerritorios.volumeMedioTerritorio }} (t)

                        .visualizar-contrato-originacao__card__territorios(
                            style='padding-right: 13px'
                        )
                            span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeMinimoPorTerritorio') }}
                            span {{ payload.volumeTerritorios.volumeMinimoTerritorio }} (t)

                    section
                        .visualizar-alerta
                            el-alert(
                                :title='`${payload.territoriosForaMunicipioContrato.output}`',
                                type='warning',
                                show-icon,
                                :closable='false',
                                v-if='payload.territoriosForaMunicipioContrato.existeMunicipioFora'
                            )
                    section
                        .visualizar-contrato-originacao__resumo-total.d-flex
                            section(style='width: 50%')
                                .div.table-header.table-border
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.resumo') }}
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.total') }}
                                .div.table-column.table-border
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeContratado') }}
                                    span {{ payload.resumo.volumeContratado }}
                                .div.table-column.table-column-active.table-border
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeConforme') }}
                                    span {{ payload.resumo.volumeConforme }}
                                .div.table-column.table-border
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeAlerta') }}
                                    span {{ payload.resumo.volumeComAlertas }}
                                .div.table-column.table-column-active.table-border
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.volumeEntregue') }}
                                    span {{ payload.resumo.volumeEntregue }}

                            section(style='width: 50%')
                                .div.table-header
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.resumo') }}
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.total') }}
                                .div.table-column
                                    span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.numeroTerritorios') }}
                                    span {{ payload.resumo.territoriosInseridos }}
                                .div.table-column.table-column-active
                                    div
                                        i.mr-2.mt-2.flow.flow-verified.verde.custon-icon
                                        span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.numeroTerritoriosConforme') }}
                                    span {{ payload.resumo.territoriosConforme }}
                                .div.table-column
                                    div
                                        i.mr-2.mt-2.flow.flow-warning-sign.custon-icon
                                        span {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.numeroTerritoriosAlerta') }}
                                    span {{ payload.resumo.territoriosComAlertas }}
                                .div.table-column.table-column-active
            section.mt-4.mb-4(
                v-if='(payload.dadosContratoOriginacao.eudr && ambienteBrasil) || isBe8'
            )
                TabelaCarsInseridosNoContrato(
                    ref='tabelaTerritorio',
                    :btnRecarregar='true',
                    :dados='contratoOriginacao',
                    :territoriosNaoEnviados='dataTerritoriosNaoEnviados',
                    :removendo='removendoTerritoriosCertificados',
                    :volumeDisponivelContrato='volumeDisponivelContrato',
                    :carregando='loadingTabelaCarsInseridosNoContrato',
                    :paginacao='paginacao',
                    @removerTerritorioLote='removerTerritorioLote',
                    @territorioRemovido='atualizarTabela',
                    @removerTerritorioBlocoInserirContratoUploadPlanilha='removerTerritorioBlocoInserirContratoUploadPlanilha',
                    @mudarPagina='mudarPagina',
                    @realizarElegibilidade='realizarElegibilidade',
                    @reprocessarElegibilidade='reprocessarElegibilidade',
                    @visualizarAnaliseElegibilidade='visualizarAnaliseElegibilidade',
                    @atualizarTabela='atualizarTabela'
                )
                ModalAnaliseElegibilidade(
                    :show='ativarModalAnaliseElegibilidade',
                    :dados='dadosAnaliseElegibilidade',
                    :raiosPermitidosPorEstado='raiosPermitidosPorEstado',
                    @handleCloseModalAnaliseElegibidade='ativarModalAnaliseElegibilidade = false'
                )
            h1 {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.resumo.numeroTerritoriosAguardando') }}
            TabelaSolicitacaoAnaliseCAR(:carregando='this.carregandoTabela')
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import Card from '@/components/Card';
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa';
import TabelaSolicitacaoAnaliseCAR from '@/components/contratosOriginacao/EmpresaTabelaSolicitacaoAnaliseCar';
import { mapGetters } from 'vuex';
import CardEmpresaVisualizarContratoAlvorada from './CardEmpresaVisualizarContratoAlvorada.vue';

import TabelaCarsInseridosNoContrato from '@/components/contratosOriginacao/TabelaCarsInseridosNoContratoEmpresa.vue';

import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import { mascaraRenspa } from '@/utils/masks/renspa.js';
import RaioPermitidoPorEstadoRastreabilidadeService from '@/services/RaioPermitidoPorEstadoRastreabilidadeService';
import MunicipioService from '@/services/MunicipioService';
import EstadoService from '@/services/EstadoService';
import ModalAnaliseElegibilidade from '@/components/contratosOriginacao/ModalAnaliseElegibilidade.vue';

export default {
    name: 'VisualizarContratoOriginacaoEmpresa',
    components: {
        Card,
        CardEmpresaVisualizarContratoAlvorada,
        BaseHeader,
        TabelaSolicitacaoAnaliseCAR,
        ModalAnaliseElegibilidade,
        TabelaCarsInseridosNoContrato
    },
    data: () => ({
        ativarModalAnaliseElegibilidade: false,
        raiosPermitidosPorEstado: [],
        contratoOriginacao: {},
        dadosAnaliseElegibilidade: {
            elegibilidade: '',
            valor: '',
            safraNome: '',
            dadosDiagnostico: {
                territorioNome: '',
                diagnosticoRepresentante: [],
                diagnosticoCar: null,
                resultadoDiagnosticoRastreabilidade: null,
                nivelAlertaRastreabilidade: null
            },
            dadosCalculoRaio: {
                distanciaRaioMunicipioECar: null,
                possuiIntersecao: null
            },
            dadosBuscaSaldo: {
                id: null,
                codigoCar: '',
                capacidadeProdutiva: null,
                saldoCARcapacidadeProdutiva: null,
                calculoSaca: {
                    saldoCARcapacidadeProdutivaSaca: null,
                    saldoCarComprometido: null
                },
                cultura: {
                    id: null,
                    nome: '',
                    codigo: ''
                },
                anoSafra: {
                    id: null,
                    ano: null,
                    tipoSafra: '',
                    descricao: ''
                },
                criadoEm: null,
                saldoCarComprometido: null
            }
        },
        loadingResumo: {
            loadingRaio: false,
            loadingSaldo: false,
            analiseElegibilidade: false
        },
        dataTerritoriosNaoEnviados: [],
        ambientes: AmbientesEmpresas,
        removendoTerritoriosCertificados: false,
        volumeDisponivelContrato: 0,
        loadingTabelaCarsInseridosNoContrato: false,
        paginacao: {
            pagina: 0,
            total: null,
            itensPorPagina: 10
        },
        payload: {
            dadosContratoOriginacao: {
                numeroContrato: null,
                fornecedorParceiroNome: null,
                culturaNome: null,
                safraNome: null,
                volumeContratado: null,
                dataContrato: null,
                fornecedor: null,
                regionalNome: null,
                gerenteComercialNome: null,
                gerenteRegionalNome: null,
                gestorTerritorialNome: null,
                status: null,
                valorContrato: null,
                condicaoFrete: null,
                dataPagamento: null,
                localCondicaoFrete: null,
                statusEmpresaCodigo: null,
                tipoContratoOffline: null
            },
            territoriosForaMunicipioContrato: {
                existeMunicipioFora: null,
                output: null
            },
            volumeTerritorios: null,
            resumo: null
        },
        carregandoTabela: false
    }),
    computed: {
        ...mapGetters(['usuarioLogado', 'isAlvorada']),
        isBe8() {
            const nameGroup = this.usuarioLogado?.nameGroup?.toUpperCase();

            return nameGroup === 'BE8';
        },
        ambienteBrasil() {
            return (
                this.usuarioLogado.ambienteLogado === AmbientesEmpresas.BRASIL
            );
        }
    },
    mounted() {
        this.buscarDados();
    },
    methods: {
        eudrFormatado(eudr) {
            if (eudr === null || eudr === '' || eudr === undefined) {
                return '-';
            }
            return eudr
                ? this.$t('mensagens.comuns.sim')
                : this.$t('mensagens.comuns.nao');
        },
        formatarToneladaToNumber(valor) {
            return parseFloat(valor.replace(/\./g, '').replace(',', '.'));
        },
        checkRastreabilidadeOffline(contrato) {
            if (contrato.tipoContratoOffline && this.usuarioLogado.isBunge) {
                this.isRastreabilidadeOffline = true;
            }
        },
        async buscarSaldo(linhaDados) {
            this.loadingResumo.loadingSaldo = true;
            const dados = {
                codigoCar: linhaDados.resumoDiagnosticoTerritorio.imovel.codigo,
                idTerritorio: linhaDados.idTerritorio,
                nomeMaterial: this.contratoOriginacao.materialNome,
                anoSafra: this.contratoOriginacao.safraNome,
                numeroContrato: this.contratoOriginacao.numeroContrato
            };
            try {
                const response =
                    await ContratoOriginacaoServiceSubEmpresa.buscarSaldo(
                        dados,
                        true
                    );
                this.dadosAnaliseElegibilidade.dadosBuscaSaldo = response.data;
            } catch (error) {
                this.$notify.error({
                    message: error?.response?.data?.message
                });
            }
            this.loadingResumo.loadingSaldo = false;
        },
        async validarEstado(linhaDados) {
            this.loadingResumo.loadingRaio = true;
            const dados = {
                idTerritorio: linhaDados.idTerritorio,
                numeroCar: linhaDados.resumoDiagnosticoTerritorio.imovel.codigo,
                numeroContrato: this.contratoOriginacao.numeroContrato
            };

            try {
                const response = await EstadoService.ValidarEstadoAceiteCar(
                    dados,
                    true
                );
                this.dadosAnaliseElegibilidade.dadosRestricaoEstado =
                    response.data;
            } catch (error) {
                if (
                    error.response.data.message ===
                    this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.numeroCarVegaApi'
                    )
                ) {
                    this.loadingResumo.loadingRaio = false;
                    return;
                } else {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                }
            }
            this.loadingResumo.loadingRaio = false;
        },
        reprocessarElegibilidade(territorioAnalise) {
            try {
                this.$nextTick(async () => {
                    await this.$refs.tabelaTerritorio.removerTerritoriosEmLote(
                        territorioAnalise
                    );
                    this.atualizarTabela();
                });
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.erroRemoverTerritorio'
                    )
                });
            }
        },
        async buscarRaiosPermitidosPorEstado() {
            const { data } =
                await RaioPermitidoPorEstadoRastreabilidadeService.findAll();
            this.raiosPermitidosPorEstado = data;
        },
        async calcularRaio(linhaDados) {
            this.loadingResumo.loadingRaio = true;
            const dados = {
                idTerritorio: linhaDados.idTerritorio,
                numeroCar: linhaDados.resumoDiagnosticoTerritorio.imovel.codigo,
                numeroContrato: this.contratoOriginacao.numeroContrato
            };

            try {
                const response =
                    await MunicipioService.ValidarMunicipioRaioAceiteCar(
                        dados,
                        true
                    );
                this.dadosAnaliseElegibilidade.dadosCalculoRaio = response.data;
            } catch (error) {
                if (
                    error.response.data.message ===
                    this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.numeroCarVegaApi'
                    )
                ) {
                    this.loadingResumo.loadingRaio = false;
                    return;
                } else {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                }
            }
            this.loadingResumo.loadingRaio = false;
        },
        atualizarTabela() {
            this.paginacao = {
                pagina: 0,
                total: null,
                itensPorPagina: 10
            };
            this.buscarTerritorios(this.paginacao.pagina);
            this.buscarDadosGerais();
        },
        async atualizarLista() {
            this.loadingTabelaCarsInseridosNoContrato = true;
            this.paginacao = {
                pagina: 0,
                total: null,
                itensPorPagina: 10
            };
            try {
                await this.buscarTerritorios(0);
                this.buscarDadosGerais();
            } finally {
                this.loadingTabelaCarsInseridosNoContrato = false;
            }
        },
        removerTerritorioLote(territorioRemover) {
            this.territoriosSelecionados = territorioRemover;
        },
        removerTerritorioBlocoInserirContratoUploadPlanilha(
            territoriosSelecionados
        ) {
            if (this.$refs.blocoDadosContratoUpload) {
                this.$refs.blocoDadosContratoUpload.removerTerritorioBlocoInserirContratoUploadPlanilha(
                    territoriosSelecionados
                );
            }
        },
        visualizarAnaliseElegibilidade(row) {
            if (
                this.loadingResumo.loadingRaio ||
                this.loadingResumo.loadingSaldo
            ) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.modalCarregando'
                    )
                });
                return;
            }

            this.dadosAnaliseElegibilidade.safraNome =
                this.contratoOriginacao.safraNome;
            this.dadosAnaliseElegibilidade.dadosBuscaSaldo.codigoCar =
                row.territorioNome;
            this.dadosAnaliseElegibilidade.dadosBuscaSaldo.cultura.codigo =
                this.contratoOriginacao.materialNome.split(' ')[0];
            this.dadosAnaliseElegibilidade.elegibilidade =
                row.codigoStatusElegibilidade;

            this.dadosAnaliseElegibilidade.dadosDiagnostico.diagnosticoRepresentante =
                row.resumoDiagnosticoRepresentantes;
            this.dadosAnaliseElegibilidade.dadosDiagnostico.diagnosticoCar =
                row.resumoDiagnosticoTerritorio;
            this.dadosAnaliseElegibilidade.dadosDiagnostico.territorioNome =
                row.territorioNome;
            this.dadosAnaliseElegibilidade.nivelAlertaRastreabilidade =
                row.nivelAlertaRastreabilidade;
            this.calcularRaio(row);
            this.validarEstado(row);
            this.buscarSaldo(row);
            this.ativarModalAnaliseElegibilidade = true;
        },
        buscarDadosGerais() {
            this.loadingTabelaCarsInseridosNoContrato = true;
            try {
                if (
                    this.usuarioLogado.ambienteLogado ===
                    AmbientesEmpresas.PARAGUAY
                ) {
                    ContratoOriginacaoServiceSubEmpresa.dadosContratoSubempresaPY(
                        this.$route.params.id
                    ).then(({ data }) => {
                        this.contratoOriginacao = data;
                        this.checkRastreabilidadeOffline(
                            this.contratoOriginacao
                        );
                        this.volumeDisponivelContrato =
                            this.formatarToneladaToNumber(data.saldoRestante);
                    });
                } else if (
                    this.usuarioLogado.ambienteLogado ===
                    AmbientesEmpresas.ARGENTINA
                ) {
                    ContratoOriginacaoServiceSubEmpresa.buscarVisualizarProcessamentoSubEmpresaAR(
                        { numeroContrato: this.$route.params.id }
                    ).then(({ data }) => {
                        this.contratoOriginacao = data;
                        this.checkRastreabilidadeOffline(
                            this.contratoOriginacao
                        );
                        this.volumeDisponivelContrato =
                            this.formatarToneladaToNumber(data.saldoRestante);
                    });
                } else {
                    ContratoOriginacaoServiceSubEmpresa.dadosContratoSubempresa(
                        this.$route.params.id
                    ).then(({ data }) => {
                        this.contratoOriginacao = data;
                        this.checkRastreabilidadeOffline(
                            this.contratoOriginacao
                        );
                        this.volumeDisponivelContrato =
                            this.formatarToneladaToNumber(data.saldoRestante);
                    });
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.erro'
                    )
                });
            }

            setTimeout(() => {
                this.loadingTabelaCarsInseridosNoContrato = false;
            }, 2000);
        },
        async realizarAnalise() {
            // esse realizar saiu daqui e doi foi para o botãi de adicionar a lista
            try {
                if (this.dataTerritoriosNaoEnviados.length === 0) {
                    this.$notify.warning({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.realizarAnalise'
                        )
                    });
                    return;
                }

                this.loading = true;

                const data = this.dataTerritoriosNaoEnviados.map(territorio => {
                    return {
                        idTerritorio: territorio.idTerritorio,
                        numeroContrato: territorio.numeroContrato,
                        volume: parseFloat(territorio.volume),
                        numeroCar: territorio.numeroCar,
                        idFonte:
                            this.dadosAnaliseElegibilidade.dadosBuscaSaldo
                                .fonteDados.id
                    };
                });

                const response =
                    await ContratoOriginacaoServiceSubEmpresa.inserirDadosContrato(
                        data
                    );

                this.$notify.success({
                    message: response.data.mensagemCadastroSucesso
                });
                this.$router.push({ name: 'RastreabilidadeSubEmpresa' });
            } catch (error) {
                this.exibirNotificacoesErros(error);
            } finally {
                this.loading = false;
            }
        },
        adicionarDadosTerritorio(dadosTerritorio) {
            if (dadosTerritorio.idTerritorio) {
                const foundId = this.dataTerritoriosNaoEnviados.find(
                    element =>
                        element.idTerritorio === dadosTerritorio.idTerritorio
                );
                if (foundId) {
                    this.exibirMensagemError(
                        this.$t(
                            'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.territorioInserido'
                        )
                    );
                    return;
                }
            }

            if (dadosTerritorio.numeroCar) {
                const foundCar = this.dataTerritoriosNaoEnviados.find(
                    element => element.numeroCar === dadosTerritorio.numeroCar
                );

                if (foundCar) {
                    this.exibirMensagemError(
                        this.$t(
                            'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.territorioInserido'
                        )
                    );
                    return;
                }
            }

            this.$notify.success({
                message: dadosTerritorio.mensagemCadastroSucesso
            });

            this.$refs.tabelaTerritorio.carregarTabela(true);
            this.dataTerritoriosNaoEnviados.push(dadosTerritorio);
            this.volumeDisponivelContrato -= dadosTerritorio.volume;

            setTimeout(() => {
                this.$refs.tabelaTerritorio.carregarTabela(false);
            }, 500);
        },
        async removerTerritorio() {
            if (this.territoriosSelecionados.length === 0) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.naoHaterritorios'
                    )
                );
            } else {
                await this.$messageBox.confirm(
                    this.territoriosSelecionados.length === 1
                        ? this.$t(
                              'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.confirmarRemoverTerritorio'
                          )
                        : this.$t(
                              'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.confirmarRemoverTerritorios'
                          ),
                    this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.aviso'
                    ),
                    {
                        confirmButtonText: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.sim'
                        ),
                        cancelButtonText: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.cancelar'
                        ),
                        type: 'warning'
                    }
                );
                try {
                    this.$nextTick(async () => {
                        await this.removerTerritoriosEmLote(
                            this.territoriosSelecionados
                        );
                        this.removerTerritorioBlocoInserirContratoUploadPlanilha(
                            this.territoriosSelecionados
                        );
                        this.atualizarTabela();
                    });
                } catch (error) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.preenchercontratooriginacao.mensagem.erroRemoverTerritorio'
                        )
                    });
                }
            }
        },
        async buscarTerritorios(pagina) {
            this.loadingTabelaCarsInseridosNoContrato = true;
            this.paginacao.pagina = pagina;

            let data = null;
            if (
                this.usuarioLogado.ambienteLogado === AmbientesEmpresas.PARAGUAY
            ) {
                data = (
                    await ContratoOriginacaoServiceSubEmpresa.buscarTerritoriosPreencherContratoPY(
                        {
                            contrato: this.$route.params.id,
                            pagina: this.paginacao.pagina,
                            tamanho: this.paginacao.itensPorPagina
                        }
                    )
                ).data;
            } else if (
                this.usuarioLogado.ambienteLogado ===
                AmbientesEmpresas.ARGENTINA
            ) {
                data = (
                    await ContratoOriginacaoServiceSubEmpresa.buscarTerritoriosPreencherContratoAR(
                        {
                            contrato: this.$route.params.id,
                            pagina: this.paginacao.pagina,
                            tamanho: this.paginacao.itensPorPagina
                        }
                    )
                ).data;
            } else {
                data = (
                    await ContratoOriginacaoServiceSubEmpresa.buscarTerritoriosPreencherContrato(
                        {
                            contrato: this.$route.params.id,
                            pagina: this.paginacao.pagina,
                            tamanho: this.paginacao.itensPorPagina
                        }
                    )
                ).data;
            }
            const resnpaFormatado = data.itens.map(item => ({
                ...item,
                cuit: this.alterarMascara(
                    item.territorioRepresentantes[0]?.cpfCnpj
                ),
                renspaTerritorio: mascaraRenspa(item.renspaTerritorio)
            }));

            this.usuarioLogado.ambienteLogado === 'AR'
                ? (this.dataTerritoriosNaoEnviados = resnpaFormatado)
                : (this.dataTerritoriosNaoEnviados = data.itens);
            this.paginacao = { ...data.paginacao };
            this.paginacao.pagina += 1;

            this.loadingTabelaCarsInseridosNoContrato = false;
        },
        alterarMascara(cpf) {
            let novaMascara = '';

            if (cpf && cpf.length > 0) {
                const somenteNumeros = cpf.replace(/\D/g, '');
                novaMascara = somenteNumeros.replace(
                    /^(\d{2})(\d{8})(\d)$/,
                    '$1-$2-$3'
                );
            }

            return novaMascara;
        },
        mudarPagina(novaPagina) {
            this.buscarTerritorios(novaPagina);
        },
        realizarElegibilidade(territorioAnalise) {
            this.territoriosSelecionados = territorioAnalise;
        },
        async buscarDados() {
            await ContratoOriginacaoServiceEmpresa.buscarContratoOriginacao(
                this.$route.params.id
            )
                .then(({ data }) => {
                    this.payload = data;
                    if (
                        (this.payload.dadosContratoOriginacao.eudr &&
                            this.ambienteBrasil) ||
                        this.isBe8
                    ) {
                        this.buscarRaiosPermitidosPorEstado();
                        this.buscarDadosGerais();
                        this.buscarTerritorios(0);
                    }
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                    this.$router.push({ path: '/rastreabilidade/empresa' });
                });
        },
        mostrarDadosVolumeTerritorio() {
            return this.payload.resumo && this.payload.volumeTerritorios;
        },
        editarContrato() {
            this.$router.push({
                name: 'EditarContratoOriginacaoEmpresa',
                params: {
                    id: this.payload.dadosContratoOriginacao.numeroContrato
                }
            });
        },
        getTitulo() {
            if (this.payload.dadosContratoOriginacao.condicaoFrete === 'CIF') {
                return this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.localDeEntrega'
                );
            } else {
                return this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.localDeRetirada'
                );
            }
        },
        formatarNumeroContrato(numeroContrato) {
            if (this.usuarioLogado.nameGroup === 'VITERRA') {
                const contratoStr = String(numeroContrato)
                    .replace(/\D/g, '')
                    .padStart(10, '0');
                const parte1 = contratoStr.slice(0, 7);
                const parte2 = contratoStr.slice(7);
                return `${parte1}-${parte2}`;
            }
            return numeroContrato;
        }
    }
};
</script>

<style lang="scss" scoped>
#visualizar-contrato-originacao {
    .visualizar-contrato-originacao__body {
        padding: 20px 33px 20px 20px;
        overflow-y: auto;
    }

    .visualizar-contrato-originacao__card {
        gap: 10px;
        display: grid;

        h1 {
            font-size: 16px;
            font-weight: bold;
            line-height: 19px;
            margin-top: 15px;
        }

        .button-edicao-contrato {
            display: flex;
            justify-content: flex-end;
        }
    }

    .visualizar-contrato-originacao__territorio_resumo {
        h2.mt-4.mb-4 {
            font-size: 16px;
            font-weight: bold;
        }
    }

    .visualizar-contrato-originacao__card__territorios {
        height: 80px;
        width: 100%;
        padding: 20px;
        border-radius: $default-border-radius;
        background: white;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--primary);
    }

    .d-flex.mb-4 {
        margin-top: 15px;
    }

    .visualizar-contrato-originacao__resumo-total {
        width: 100%;
        background: white;
        border-radius: $default-border-radius;
    }

    .table-header {
        color: var(--primary);
        font-weight: 600;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        padding: 15px 20px;
        border-bottom: solid 1px #a1a1a1ff;
    }

    .table-column {
        padding: 15px 20px;
        height: 50px;
        font-size: 14px;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
    }

    .table-column-active {
        background: #ecececcf;
    }

    .table-border {
        border-right: solid 1px #a1a1a1ff;
    }

    .data-display {
        display: flex;
        flex-direction: column;
        padding: 15px 20px;

        .data-title {
            font-size: 14px;
            margin-bottom: 8px;
            color: var(--primary);
            font-weight: 600;
        }

        .data-value {
            font-size: 14px;
            color: #636363;
        }
    }

    .mr-2.mt-2.flow.flow-warning-sign.custon-icon {
        color: var(--warning);
    }

    .visualizar-alerta {
        padding-bottom: 20px;
    }
}
</style>
